import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { L } from "@/i18n";

export const SortHeader = ({ label, pt, sortKey, sort, onSort, className }) => {
  const active = sort.key === sortKey;
  const Icon = !active ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={className} aria-sort={active ? (sort.dir === "asc" ? "ascending" : "descending") : "none"}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        data-testid={`users-sort-${sortKey}`}
        className={`inline-flex items-center gap-1.5 uppercase tracking-[0.15em] transition-colors ${active ? "text-amber-400" : "hover:text-slate-200"}`}
      >
        {L(label, pt)}
        <Icon className="h-3 w-3" />
      </button>
    </th>
  );
};
